(function () {
  "use strict";

  var t = {
    242: function _(t, e, n) {
      var _r,
          o = this && this.__extends || (_r = function r(t, e) {
        return _r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          }
        }, _r(t, e);
      }, function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");

        function n() {
          this.constructor = t;
        }

        _r(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
      }),
          i = this && this.__assign || function () {
        return i = Object.assign || function (t) {
          for (var e, n = 1, r = arguments.length; n < r; n++) {
            for (var o in e = arguments[n]) {
              Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            }
          }

          return t;
        }, i.apply(this, arguments);
      },
          u = this && this.__awaiter || function (t, e, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function u(t) {
            try {
              a(r.next(t));
            } catch (t) {
              i(t);
            }
          }

          function s(t) {
            try {
              a(r.throw(t));
            } catch (t) {
              i(t);
            }
          }

          function a(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof n ? e : new n(function (t) {
              t(e);
            })).then(u, s);
          }

          a((r = r.apply(t, e || [])).next());
        });
      },
          s = this && this.__generator || function (t, e) {
        var n,
            r,
            o,
            i,
            u = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");

              for (; u;) {
                try {
                  if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                  switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                    case 0:
                    case 1:
                      o = i;
                      break;

                    case 4:
                      return u.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      u.label++, r = i[1], i = [0];
                      continue;

                    case 7:
                      i = u.ops.pop(), u.trys.pop();
                      continue;

                    default:
                      if (!((o = (o = u.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                        u = 0;
                        continue;
                      }

                      if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                        u.label = i[1];
                        break;
                      }

                      if (6 === i[0] && u.label < o[1]) {
                        u.label = o[1], o = i;
                        break;
                      }

                      if (o && u.label < o[2]) {
                        u.label = o[2], u.ops.push(i);
                        break;
                      }

                      o[2] && u.ops.pop(), u.trys.pop();
                      continue;
                  }

                  i = e.call(t, u);
                } catch (t) {
                  i = [6, t], r = 0;
                } finally {
                  n = o = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var a = n(158),
          c = n(809),
          l = n(64),
          f = function (t) {
        function e(e) {
          var n = e.network,
              r = e.addressType,
              o = void 0 === r ? l.yacoin.AddressType.LEGACY : r;
          return t.call(this, {
            network: n,
            addressType: o
          }) || this;
        }

        return o(e, t), e.prototype.request = function (t) {
          for (var e = [], n = 1; n < arguments.length; n++) {
            e[n - 1] = arguments[n];
          }

          return u(this, void 0, void 0, function () {
            return s(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, window.yacoin.enable()];

                case 1:
                  return n.sent(), [2, window.yacoin.request({
                    method: t,
                    params: e
                  })];
              }
            });
          });
        }, e.prototype.getAddresses = function (t, e, n) {
          return void 0 === t && (t = 0), void 0 === e && (e = 1), void 0 === n && (n = !1), u(this, void 0, void 0, function () {
            return s(this, function (r) {
              return [2, this.request("wallet_getAddresses", t, e, n)];
            });
          });
        }, e.prototype.signMessage = function (t, e) {
          return u(this, void 0, void 0, function () {
            return s(this, function (n) {
              return [2, this.request("wallet_signMessage", t, e)];
            });
          });
        }, e.prototype.signTx = function (t, e, n, r) {
          return u(this, void 0, void 0, function () {
            return s(this, function (o) {
              return [2, this.request("wallet_signTx", t, e, n, r)];
            });
          });
        }, e.prototype.sendTransaction = function (t) {
          return u(this, void 0, void 0, function () {
            return s(this, function (e) {
              return [2, this.request("wallet_sendTransaction", i(i({}, t), {
                value: t.value.toNumber()
              }))];
            });
          });
        }, e.prototype.getConnectedNetwork = function () {
          return u(this, void 0, void 0, function () {
            return s(this, function (t) {
              return [2, this.request("wallet_getConnectedNetwork")];
            });
          });
        }, e.prototype.isWalletAvailable = function () {
          return u(this, void 0, void 0, function () {
            return s(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, this.getAddresses()];

                case 1:
                  return [2, t.sent().length > 0];
              }
            });
          });
        }, e;
      }((0, a.YacoinWalletProvider)(c.WalletProvider));

      e.default = f;
    },
    175: function _(t, e, n) {
      var r = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.YacoinWalletApiProvider = void 0;
      var o = r(n(242));
      e.YacoinWalletApiProvider = o.default;
    },
    64: function _(t) {
      t.exports = require("@yaswap/types");
    },
    809: function _(t) {
      t.exports = require("@yaswap/wallet-provider");
    },
    158: function _(t) {
      t.exports = require("@yaswap/yacoin-wallet-provider");
    }
  },
      e = {},
      n = function n(r) {
    var o = e[r];
    if (void 0 !== o) return o.exports;
    var i = e[r] = {
      exports: {}
    };
    return t[r].call(i.exports, i, i.exports, n), i.exports;
  }(175);

  module.exports = n;
})();